import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 60 * 1000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (config.url.indexOf('s=') === -1) {
    config.url = config.url.indexOf('?') !== -1 ? `${config.url}&s=${new Date().getTime()}` : `${config.url}?s=${new Date().getTime()}`
  }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非1是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res && res.status !== 0) {
      return Promise.reject({status: res.status, message: res.message})
    } else {
      return res
    }
  },
  error => {
    Message({
      type: 'error',
      message: `${error.response.status} Error ${error.response.statusText}`,
      center: true,
      duration: 2 * 1000
    })
    return Promise.reject(null)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js